import { ENVS, ENV_NAME } from "./envs";

export const centralLoginUrl =
	ENVS?.[ENV_NAME]?.VITE_CENTRAL_LOGIN_URL || "https://dev-accounts.konfhub.com";

export const appUrl = `https://${ENVS?.[ENV_NAME]?.VITE_APP_URL}` || "https://dev-gallery.konfhub.com";

export const graphqlPublicApiKey =
	ENVS?.[ENV_NAME]?.VITE_GRAPHQL_PUBLIC_API_KEY || "da2-r3oju7njvrbhhed2egv3nel6jy";

export const spinnerStyle = {
	position: "fixed" as const,
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	zIndex: 9999,
	color: "var(--primary-color)"
};